module.exports = __webpack_public_path__ + "img/redux_thumb.bb09eba9.jpg";